import { useState } from 'react';
import { Headline6 } from '@material/react-typography';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@upmc/ims.component-library';
import SearchIcon from '@mui/icons-material/Search';

import { callApiPopulate } from 'store/apps/actions';
import inputClasses from 'components/UI/Input/Input.module.scss';
import ADGroupsLookupDialog from './ADGroupsLookupDialog';

const ADGroupsSearch = props => {
	const dispatch = useDispatch();
	const [isLookupOpen, setIsLookupOpen] = useState(false);
	const allForms = useSelector(state => state.apps.allForms);
	const formIndex = Object.keys(allForms).find(
		key => allForms[key].id === props.appId
	);
	const hasFormIndex = formIndex !== undefined;
	const model = hasFormIndex ? allForms[formIndex]?.model : null;

	let extras = {};
	if (props.extras) {
		try {
			extras =
				typeof props.extras === 'string'
					? JSON.parse(props.extras)
					: props.extras;
		} catch (e) {
			extras = {};
		}
	}

	const isDisabled =
		Array.isArray(extras.disabled) && extras.disabled.length > 0;
	const targetComponentKey =
		extras?.targetComponentKey ??
		extras?.adgroupssearch?.action?.targetComponentKey ??
		extras?.popupiconbutton?.action?.targetComponentKey ??
		null;

	const handleOpenLookup = () => {
		setIsLookupOpen(true);
	};

	const handleCloseLookup = () => {
		setIsLookupOpen(false);
	};

	const handleSelectGroups = selection => {
		if (!model || !targetComponentKey) {
			handleCloseLookup();
			return;
		}

		const selectedGroups = Array.isArray(selection)
			? selection
			: selection
				? [selection]
				: [];

		if (selectedGroups.length === 0) {
			handleCloseLookup();
			return;
		}

		const joinedValue = selectedGroups.map(g => g.GroupName);
		const applySelectedGroupsToModel = (
			currentModel,
			currentTargetComponentKey,
			currentJoinedValue
		) => {
            if (
				!currentModel ||
				!currentModel.members ||
				!currentTargetComponentKey ||
				!Object.keys(currentModel.members).includes(currentTargetComponentKey)
            ) {
				return currentModel;
            }

			const targetComponent = currentModel.members[currentTargetComponentKey];
            const currentValue = targetComponent.value || '';
            
            // Merge groups without duplicates
            const existingGroups = currentValue.length > 0 ? currentValue.split('~~') : [];
            const uniqueGroups = [...new Set([...existingGroups, ...currentJoinedValue])];
            targetComponent.value = uniqueGroups.join('~~');

            let populationRoute = JSON.parse(
                targetComponent.elementConfig.options[targetComponent.id].PopulationRoute);

            if (populationRoute 
				&& populationRoute.hasOwnProperty('setActions') 
				&& populationRoute.setActions !== null) 
			{
                const newGroupsOnly = currentJoinedValue.filter(g => !existingGroups.includes(g));
                populationRoute.setActions[0].value = newGroupsOnly.join('~~');
                populationRoute = JSON.stringify(populationRoute);
                targetComponent.populationRoute = populationRoute;
                targetComponent.elementConfig.options[targetComponent.id].PopulationRoute = populationRoute;
            }

			currentModel.members[currentTargetComponentKey] = targetComponent;
			return currentModel;
        };

		const updatedModel = applySelectedGroupsToModel(
			model,
			targetComponentKey,
			joinedValue
		);

		dispatch(
			callApiPopulate({
				watchComponentKey: targetComponentKey,
				formToPopulateKey: formIndex,
				allMembers: updatedModel?.members,
				trackingNumber: updatedModel?.TrackingNumber,
			})
		);

		handleCloseLookup();
	};

	return (
		<>
			{props.label ? (
				<Headline6 className={inputClasses.label}>
					{props.label}
				</Headline6>
			) : null}           
			<div className={inputClasses['interactive-element']}>
				<Button
					onClick={handleOpenLookup}
                    id={`${props.appId}_${props.formElId}_adgroupssearch_button`}
					variant='outlined'
					disabled={isDisabled}
                    startIcon={<SearchIcon fontSize='small' />}
				>
					Search for Groups
				</Button>
			</div>
			<ADGroupsLookupDialog
                id={`${props.appId}_${props.formElId}_adgroupslookupdialog`}
				open={isLookupOpen}
				onClose={handleCloseLookup}
				onSelect={handleSelectGroups}
			/>
		</>
	);
};

export default ADGroupsSearch;

